<template>
  <div>
    <div class="filters">
      <div class="flex">
        <div class="filter-item">
          <span>时间选择：</span>
          <el-date-picker
            v-model="dateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :clearable="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="chooseDate"
          >
          </el-date-picker>
        </div>
        <!-- <div class="filter-item">
          <span>交易类型：</span>
          <el-select v-model="dataType" placeholder="请选择">
            <el-option label="收入" value="income" />
            <el-option label="支出" value="expend" />
          </el-select>
        </div> -->
      </div>
      <div>
        <el-button type="primary" plain icon="el-icon-search" size="small" class="search-btn" @click="getRechargeList">查询</el-button>
        <!-- <el-button type="warning" style="border-radius: 14px" class="el-icon-download" plain> 导出明细</el-button> -->
      </div>
    </div>
    <el-table
      :show-header="false"
      :data="rechargeList"
      v-loading="laodRecharge"
      height="calc(100vh - 350px)"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      class="balance-table"
    >
      <el-table-column>
        <template slot-scope="scope">
          <div class="item-box">
            <div class="item-icon">
              <!-- <i class="iconfont iconicon-1"></i> -->
              <img src="https://picture.aiyizhijian.com/image/png/647282442138748160.png" alt="" style="width: 100%; height: 100%" />
            </div>
            <div class="item-text">
              <div class="big bold">
                订单编号: <span style="color: #2d99d7">{{ scope.row.DocumentNo ? scope.row.DocumentNo : '' }}</span>
              </div>
              <div class="small" v-if="scope.row.Recharge_record_library.length > 0">
                支付单号:{{ scope.row.Recharge_record_library[0].DocumentNo }}
              </div>
              <div class="small">{{ scope.row.Creationtime ? scope.row.Creationtime : '' }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="200">
        <template slot-scope="scope">
          <div class="small" v-if="scope.row.Recharge_record_library.length > 0">
            <el-tag>
              {{
                scope.row.Recharge_record_library[0].rcs_Scheme_description
                  ? scope.row.Recharge_record_library[0].rcs_Scheme_description
                  : '无描述活动'
              }}</el-tag
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column width="120" prop="rcs_Recharge_points">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state === '结算成功'" type="success">结算成功</el-tag>
          <el-tag v-if="scope.row.state === '完成支付'" type="success">完成支付</el-tag>
          <el-tag v-if="scope.row.state === '待支付'" type="danger">待支付</el-tag>
          <el-tag v-if="!scope.row.state" type="danger">暂未结算</el-tag>
        </template>
      </el-table-column>

      <el-table-column width="120" prop="rcs_Recharge_amount">
        <template slot-scope="scope">
          <div class="big bold text-color-success" v-if="scope.row.rcs_Recharge_amount > 0">+{{ scope.row.rcs_Recharge_amount }}</div>
          <div class="big bold text-color-danger" v-else>
            {{ scope.row.rcs_Recharge_amount }}
          </div>
          <div class="small">账户余额</div>
        </template>
      </el-table-column>
      <el-table-column width="120" prop="rcs_Recharge_points">
        <template slot-scope="scope">
          <div class="big bold text-color-success" v-if="scope.row.rcs_Recharge_points > 0">+{{ scope.row.rcs_Recharge_points }}</div>
          <div class="big bold text-color-danger" v-else>
            {{ scope.row.rcs_Recharge_points }}
          </div>
          <div class="small">E豆</div>
        </template>
      </el-table-column>
      <el-table-column type="expand" width="50">
        <template slot-scope="scope">
          <div v-if="scope.row.Recharge_record_library.length > 0">
            <span class="recharge-tip">充值金额（本次）：{{ scope.row.rcs_Recharge_amount }}</span>
            <span class="recharge-tip"> 充值金额已使用（本次）：{{ scope.row.Recharge_record_library[0].recl_Usage_amount }} </span>
            <span class="recharge-tip2"> 充值金额剩余（本次）：{{ scope.row.Recharge_record_library[0].recl_Remaining_amount }} </span>
          </div>
          <div v-if="scope.row.Recharge_record_library.length > 0">
            <span class="recharge-tip">赠送E豆（本次）：{{ scope.row.rcs_Recharge_points }} </span>
            <span class="recharge-tip"> 赠送E豆已使用（本次）：{{ scope.row.Recharge_record_library[0].recl_Using_points }} </span>
            <span class="recharge-tip2"> 赠送E豆剩余（本次）：{{ scope.row.Recharge_record_library[0].recl_Residual_integral }} </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import request from '@/utils/request';
import moment from 'moment';
export default {
  name: 'RechargeData',
  data() {
    return {
      dateRange: [],
      dataType: '',
      startTime: '', //左侧时间
      endTime: '', //右侧时间
      rechargeList: [],
      laodRecharge: false
    };
  },
  filters: {
    sexFilter(val) {
      return val === 'male' ? '男' : val === 'female' ? '女' : '未知';
    }
  },
  created() {},
  mounted() {
    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
    this.startTime = moment(new Date().getTime() - 7000 * 60 * 60 * 24).format('YYYY-MM-DD');
    this.dateRange = [this.startTime, this.endTime];
    this.getRechargeList();
  },
  methods: {
    // 选择时间
    chooseDate(event) {
      if (event) {
        this.startTime = event[0];
        this.endTime = event[1];
        this.getRechargeList();
      } else {
        this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
        this.startTime = moment(new Date().getTime() - 7000 * 60 * 60 * 24).format('YYYY-MM-DD');
        this.getRechargeList();
      }
    },
    // 获取充值明细
    getRechargeList() {
      const that = this;
      that.laodRecharge = true;
      const clinicInfo = JSON.parse(sessionStorage.user);
      let dataP = {
        cal_code: clinicInfo.cal_code,
        ksdate: that.startTime,
        jsdate: that.endTime
      };
      const params = {
        token: clinicInfo.token,
        workid: '892fb900-b93b-3737-b736-89cdf49a49b8',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          that.laodRecharge = false;
          that.rechargeList = res.recharge_order.filter((key) => key.state !== '待支付');
          that.rechargeList = that.rechargeList.reverse();
          // console.log('充值明细：：', that.rechargeList);
        })
        .catch((err) => {
          that.laodRecharge = false;
          that.$message.error('抱歉，充值明细查询失败');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.recharge-tip {
  display: inline-block;
  width: 200px;
  // border: 1px solid red;
}
.recharge-tip2 {
  display: inline-block;
  width: 300px;
  // border: 1px solid red;
  text-align: center;
}
.balance-table {
  width: 100%;
  // border: 1px solid red;
}
.filters {
  display: flex;
  margin-bottom: 15px;
  .el-date-editor {
    width: 240px;
  }
  .el-select {
    width: 120px;
  }
  .filter-item {
    margin-right: 10px;
  }
}
.item-box {
  display: flex;
  .item-icon {
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    border-radius: 10px;
    // background-color: #f8ad0a;
    margin-right: 10px;
    // align-items: center;
    // display: flex;
    // justify-content: center;
    // font-size: 80px;
    // color: #fff;

    // background-size: 30px;
    // background-repeat: no-repeat;
    // background-position: center center;
    // background-image: url(~@/assets/img/shiguan.svg);
  }
  .item-text {
    line-height: 14px;
    .bold {
      line-height: 20px;
    }
  }
}
</style>
